import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[uppercase]'
})
export class UppercaseDirective {

  constructor() { }

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }
}